import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { REGISTER_CARD } from "../../redux/reducers/cardReducer";
import {
  StyledCell,
  StyledRow,
} from "../../styled-components/styledTableComponents";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import HelpIcon from "@mui/icons-material/Help";
import { Fragment } from "react";

export function RegisterCardModal() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const form = useSelector((state: any) => state.card.registrationForm);
  const carePrincipalSettings = useSelector(
    (state: any) => state.carePrincipal.carePrincipalSettings
  );

  const onSubmit = () => {
    const params = form;
    dispatch({ type: REGISTER_CARD, params });
  };

  return (
    <>
      <Box padding="0.5em" maxWidth="25em">
        <Dialog
          open={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("searchCard.menu.registerCard")}
          </DialogTitle>
          <DialogContent>
            <Stack spacing={1}>
              <Typography>
                {t("searchCard.registerCard.createCardForPerson")}
              </Typography>
              <Container
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                  width: "25em",
                }}
              >
                {form.endDate < Date.now() ? (
                  <Fragment>
                    <InfoIcon
                      sx={{ width: "4vh", height: "4vh", color: "#3399FF" }}
                    />
                    <Typography variant="h4" component="div">
                      {t("searchCard.cardInfo.status.EXPIRED")}
                    </Typography>
                  </Fragment>
                ) : carePrincipalSettings.preliminaryStatusActive &&
                  form.endDate >= Date.now() ? (
                  <Fragment>
                    <HelpIcon
                      sx={{ width: "4vh", height: "4vh", color: "#FFBF00" }}
                    />
                    <Typography variant="h4" component="div">
                      {t("searchCard.cardInfo.status.PRELIMINARY")}
                    </Typography>
                  </Fragment>
                ) : (
                  <Fragment>
                    <CheckCircleIcon
                      sx={{ width: "4vh", height: "4vh", color: "green" }}
                    />
                    <Typography variant="h4" component="div">
                      {t("searchCard.cardInfo.status.FINAL")}
                    </Typography>
                  </Fragment>
                )}
              </Container>
              <Table size="small" className="firstColumnBold">
                <TableBody>
                  <StyledRow>
                    <StyledCell>{t("searchCard.cardInfo.personId")}</StyledCell>
                    <StyledCell>{form.personId}</StyledCell>
                  </StyledRow>
                  <StyledRow>
                    <StyledCell>{t("searchCard.cardInfo.period")}</StyledCell>
                    <StyledCell>
                      {form.startDate.toLocaleDateString("sv")}
                      &nbsp;&nbsp;-&nbsp;&nbsp;
                      {form.endDate.toLocaleDateString("sv")}
                    </StyledCell>
                  </StyledRow>
                  <StyledRow>
                    <StyledCell>
                      {t("searchCard.registerCard.cardFrom")}
                    </StyledCell>
                    <StyledCell>
                      {form.preliminaryCardDate.toLocaleDateString("sv")}
                    </StyledCell>
                  </StyledRow>
                  <StyledRow>
                    <StyledCell>{t("searchCard.cardInfo.cardType")}</StyledCell>
                    <StyledCell>{t(form.cardTypeId)}</StyledCell>
                  </StyledRow>
                </TableBody>
              </Table>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => dispatch({ type: "MODAL_CANCEL" })}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => onSubmit()}
            >
              {t("register")}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
